// extracted by mini-css-extract-plugin
export var imageInnerStyle = "rsc_hb_card_cover_image-module--imageInnerStyle--t28n0";
export var isActiveStyle = "rsc_hb_card_cover_image-module--isActiveStyle--PzE6l";